import { all, fork } from 'redux-saga/effects';
import {
  watchCallToEZCheckValidator,
  watchCallToupdateTransferArchive,
  watchcallToEZCheckForTransferCreation,
  watchcallToGetStoreNames,
  watchcallToGetSourceDescriptions,
  watchcallToGetTransferStatusWorkFlow,
  watchcallToDownloadTransferList,
  watchCallInBoundTransferAction,
  watchcallToGetStoreFilterConfigData,
  watchCallToGetTransferDetails,
  watchCallToResendIinitiationEmail,
  watchCallToAssignTransferDealerHandler,
  watchCallToAssignTransferLicenseHandler,  
  watchcallToGetTransferDealerHistory,
  watchCallToSendCustomerAssignDealerEmail,
  watchCallToGenerateMasterProof,
  watchCallToGetReAssignMicroDetails,
  watchCallToSaveTransferFilters,
  watchCallToRemoveTransferFilters,
  watchCallToGetTransferFilters,
  watchCallToGetReAssignDealerHistory,
  watchCallToGetPermissionsTabs,
  watchCallToUpdatePermissionsTabs,
  watchCallToEcommerceStatus,
  watchGetAutoCompleteApiResult,
  watchCallToGetDocumentStatus,
  watchCallToGetSellerDetails,
  watchCallToGetRecieverDetails,
  watchCallToSkipStep,
  watchCallToGetEmailTemplate,
  watchCallToGetLicenseRecordDetails,
  watchCallToGetTransferFilterCollection,
  watchCallToSaveTransferFilterCollection,
  watchCallToDeleteTransferFilterCollection
} from '@/queue/ducks/saga';
import {
  watchcallToEZCheckForTransferCreation as watchcallToEZCheckForTransferCreationDealer,
  watchCallToManualReviewRequest,
  watchCallToTransferCount,
  watchForCallToGetOCRStepFunctionDetailsV2
} from '@/dealerProfile/ducks/saga';
import {
  watchCallToCreateDealerAction,
  watchCallToGetEZCheckValidatorHistory,
  watchCallToGetLicenseHistory,
  watchCallToSendProfileEditEmail,
  watchCallToRemoveLicense,
  watchCallToShootingChange,
  watchCallToSuggestedResult,
  watchCallToRefreshSerpEnrichment,
  watchCallToGetSavedFilterCollections,
  watchCallToUpsertSavedFilterCollection,
  watchCallToDeleteSavedFilterCollection
} from '@/explore/ducks/saga';
import {
  watchCallToCreateStore,
  watchCallToGetCreateStore,
  watchCallToPostCreateStore,
  watchCallToGetDealerActionTimeout,
  watchCallToStopImpersonateGlobalAdmin,
  watchCallToImpersonateGlobalAdmin,
  watchForCallToUpdateSOTPath,
  watchForCallToUpdateLOAPath,
  watchCallToGetStoreList,
  watchCallToGetTrackingData,
  watchCallToAddDealerEvent
} from './saga';
import {
  watchCallToCreateUser,
  watchCallToDeleteUser,
  watchCallToUpdateAutomateTransferWorkflow,
  watchCallToEditUser,
  watchCallToGenerateEncryptionKey,
  watchTocallToRemoveEncryptionKey,
  watchToCallToUpdateStoreConfiguration,
  watchToCallToUpdateDealerActionTimeout,
  watchToCallToUpdateStoreFilterConfig,
  watchCallToGetStoreTermsAndConditions,
  watchcallCustomWebhookTestConnection,
  watchcallCustomWebhookRotate,
  watchUpdateCustomWebhookConfiguration,
  watchGetCustomWebhookConfiguration,
  watchToCallToUpdateStoreTermsAndConditions,
  watchcallToDownloadPreferredDealersList
} from '@/storeAdmin/ducks/saga';
import {
  watchCallToGetFFLSelectConfig,
  watchCallToGetLicenseReviewDetails,
  watchCallToGetLOAReviewDetails,
  watchCallToGetReviewEmailTemplate,
  watchCallToGetSOTReviewDetails,
  watchCallToSendEmailTemplate,
  watchToCallToUpdateSelectConfiguration,
  watchCallTogetFFLExportLiveStoreFilePath
} from '@/review/ducks/saga';
import {
  watchCallToGetDealerDetail,
  watchCallToToggleLoading,
  watchCallToEmailNotFound
} from '@/dealerProfile/ducks/saga';

const rootSaga = function* () {
  yield all([
    fork(watchCallToEZCheckValidator),
    fork(watchCallToGetEZCheckValidatorHistory),
    fork(watchcallToEZCheckForTransferCreation),
    fork(watchCallToPostCreateStore),
    fork(watchCallToCreateDealerAction),
    fork(watchCallToGetLicenseHistory),
    fork(watchCallToSendProfileEditEmail),
    fork(watchcallToGetTransferStatusWorkFlow),
    fork(watchCallToGetCreateStore),
    fork(watchCallToRemoveLicense),
    fork(watchCallToRefreshSerpEnrichment),
    fork(watchCallToUpdateAutomateTransferWorkflow),
    fork(watchToCallToUpdateDealerActionTimeout),
    fork(watchCallToCreateUser),
    fork(watchCallToDeleteUser),
    fork(watchCallToEditUser),
    fork(watchcallToDownloadTransferList),
    fork(watchCallToShootingChange),
    fork(watchCallToSuggestedResult),
    fork(watchCallToupdateTransferArchive),
    fork(watchcallToGetStoreNames),
    fork(watchcallToGetSourceDescriptions),
    fork(watchcallToGetStoreFilterConfigData),
    fork(watchCallToGenerateEncryptionKey),
    fork(watchTocallToRemoveEncryptionKey),
    fork(watchToCallToUpdateStoreConfiguration),
    fork(watchToCallToUpdateStoreFilterConfig),
    fork(watchCallToCreateStore),
    fork(watchCallToGetFFLSelectConfig),
    fork(watchCallTogetFFLExportLiveStoreFilePath),
    fork(watchToCallToUpdateSelectConfiguration),
    fork(watchCallInBoundTransferAction),
    fork(watchCallToStopImpersonateGlobalAdmin),
    fork(watchCallToGetDealerActionTimeout),
    fork(watchCallToGetTransferDetails),
    fork(watchCallToImpersonateGlobalAdmin),
    fork(watchCallToStopImpersonateGlobalAdmin),
    fork(watchCallToGetStoreTermsAndConditions),
    fork(watchcallCustomWebhookTestConnection),
    fork(watchcallCustomWebhookRotate),
    fork(watchUpdateCustomWebhookConfiguration),
    fork(watchGetCustomWebhookConfiguration),
    fork(watchToCallToUpdateStoreTermsAndConditions),
    fork(watchCallToResendIinitiationEmail),
    fork(watchCallToGetDealerDetail),
    fork(watchCallToTransferCount),
    fork(watchCallToToggleLoading),
    fork(watchCallToAssignTransferDealerHandler),
    fork(watchCallToAssignTransferLicenseHandler),
    fork(watchcallToGetTransferDealerHistory),
    fork(watchcallToEZCheckForTransferCreationDealer),
    fork(watchForCallToUpdateSOTPath),
    fork(watchForCallToUpdateLOAPath),
    fork(watchcallToDownloadPreferredDealersList),
    fork(watchCallToSendCustomerAssignDealerEmail),
    fork(watchCallToGenerateMasterProof),
    fork(watchCallToEmailNotFound),
    fork(watchCallToGetReAssignMicroDetails),
    fork(watchCallToSaveTransferFilters),
    fork(watchCallToRemoveTransferFilters),
    fork(watchCallToGetTransferFilters),
    fork(watchCallToGetPermissionsTabs),
    fork(watchCallToUpdatePermissionsTabs),
    fork(watchCallToGetStoreList),
    fork(watchCallToEcommerceStatus),
    fork(watchGetAutoCompleteApiResult),
    fork(watchCallToGetReAssignDealerHistory),
    fork(watchCallToGetDocumentStatus),
    fork(watchCallToGetSellerDetails),
    fork(watchCallToGetRecieverDetails),
    fork(watchCallToSkipStep),
    fork(watchCallToGetEmailTemplate),
    fork(watchForCallToGetOCRStepFunctionDetailsV2),
    fork(watchCallToManualReviewRequest),
    fork(watchCallToGetReviewEmailTemplate),
    fork(watchCallToSendEmailTemplate),
    fork(watchCallToGetLicenseReviewDetails),
    fork(watchCallToGetLicenseRecordDetails),
    fork(watchCallToGetSOTReviewDetails),
    fork(watchCallToGetLOAReviewDetails),
    fork(watchCallToGetTrackingData),
    fork(watchCallToAddDealerEvent),
    fork(watchCallToGetSavedFilterCollections),
    fork(watchCallToUpsertSavedFilterCollection),
    fork(watchCallToDeleteSavedFilterCollection),
    fork(watchCallToGetTransferFilterCollection),
    fork(watchCallToSaveTransferFilterCollection),
    fork(watchCallToDeleteTransferFilterCollection),
  ]);
};

export default rootSaga;
